import { render, staticRenderFns } from "./SamSpan.vue?vue&type=template&id=52be2e25&scoped=true&"
import script from "./SamSpan.vue?vue&type=script&lang=js&"
export * from "./SamSpan.vue?vue&type=script&lang=js&"
import style0 from "./SamSpan.vue?vue&type=style&index=0&id=52be2e25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52be2e25",
  null
  
)

export default component.exports